<template>
    <div class="page">
        <!-- 图片预览 -->
        <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog> -->

        <div class="main-title">
            <span>查看订单详情</span>
            <!-- <button @click="$router.push('/order-list')">返回</button> -->
        </div>

        <div class="page-ctx">
            <div class="step-box">
                <div class="step-item active">
                    <div class="step-number">
                        <div class="step-line step-line-1"></div>
                        <div class="step-num">1</div>
                        <div class="step-line step-line-2"></div>
                    </div>
                    <div class="step-title">订购时间</div>
                    <div class="step-date">{{ info.createdTime }}</div>
                </div>
                <div class="step-item" :class="{ active: info.orderStatus >= 3 }">
                    <div class="step-number">
                        <div class="step-line step-line-3"></div>
                        <div class="step-num">2</div>
                        <div class="step-line step-line-4"></div>
                    </div>
                    <div class="step-title">商品发货</div>
                    <div class="step-date" style="visibility: hidden">-</div>
                </div>
                <div class="step-item" :class="{ active: info.orderStatus >= 5 }">
                    <div class="step-number">
                        <div class="step-line step-line-5"></div>
                        <div class="step-num">3</div>
                        <div class="step-line step-line-6"></div>
                    </div>
                    <div class="step-title">订单收货</div>
                    <div class="step-date" style="visibility: hidden">-</div>
                </div>
            </div>

            <div class="order-other">
                <div class="title">订单信息</div>
                <div class="other">
                    <div class="item">
                        <div class="item-title">收货人信息</div>
                        <div class="item-content">
                            <div class="name">
                                <span>收货人：</span>
                                {{ shouhuoInfo.name || shouhuoInfo.firstName + ' ' + shouhuoInfo.lastName }}
                            </div>
                            <div class="phone">
                                <span>手机号码：</span>
                                {{ shouhuoInfo.phone }}
                            </div>
                            <div class="address">
                                <span>详细地址：</span>
                                {{ full_receive_address }}
                            </div>
                        </div>
                    </div>

                    <div class="item">
                        <div class="item-title">支付及支付方式</div>
                        <div class="item-content">
                            <div class="date" v-if="is_finish_pay">
                                <span>支付方式：</span>
                                <span class="val"> {{ payTypeToStr(orderObj.payInfo) }} </span>
                            </div>

                            <div class="date">
                                <span>下单时间：</span>
                                {{ orderObj.createdTime }}
                            </div>
                        </div>
                    </div>

                    <div class="item">
                        <div class="item-title">物流信息</div>
                        <div class="item-content">
                            <div class="date">
                                <span>快递公司：</span>
                                {{ fahuoInfo.expressName ? fahuoInfo.expressName : '--' }}
                            </div>

                            <div class="date">
                                <span>快递单号：</span>
                                {{ fahuoInfo.expressOrder ? fahuoInfo.expressOrder : '--' }}
                            </div>

                            <div class="date">
                                <span>发货时间：</span>
                                {{ fahuoInfo.fahuoTime ? fahuoInfo.fahuoTime : '--' }}
                            </div>
                        </div>
                    </div>

                    <!-- 发票信息 -->
                    <div class="item" v-if="info.invioceJson">
                        <div class="item-title">发票信息</div>
                        <div class="item-content">
                            <div class="date">
                                <span>发票抬头类型：</span>
                                <span class="val"> {{ invoiceTypeToStr(info.invioceJson.invoiceType) }} </span>
                            </div>

                            <div class="date" v-if="info.invioceJson.title">
                                <span>发票抬头：</span>
                                {{ info.invioceJson.title }}
                            </div>

                            <div class="date" v-if="info.invioceJson.shibiema">
                                <span>纳税人识别号：</span>
                                {{ info.invioceJson.shibiema }}
                            </div>

                            <div class="pay-type" v-if="info.invioceJson.shibiema">
                                <span>注册地址：</span>
                                {{ info.invioceJson.shibiema }}
                            </div>

                            <div class="pay-type" v-if="info.invioceJson.companyPhone">
                                <span>注册电话：</span>
                                {{ info.invioceJson.companyPhone }}
                            </div>

                            <div class="pay-type" v-if="info.invioceJson.bankName">
                                <span>开户银行：</span>
                                {{ info.invioceJson.bankName }}
                            </div>

                            <div class="pay-type" v-if="info.invioceJson.bankNo">
                                <span>银行账户：</span>
                                {{ info.invioceJson.bankNo }}
                            </div>

                            <div class="pay-type" v-if="info.invioceJson.email">
                                <span>电子邮箱：</span>
                                {{ info.invioceJson.email }}
                            </div>
                        </div>
                    </div>

                    <div class="item" v-if="peisong_type_text == '上门自提'">
                        <div class="item-title">取货人信息</div>
                        <div class="item-content">
                            <div class="name">
                                <span>取货人：</span>
                                {{ shouhuoInfo.name }}
                            </div>
                            <div class="phone">
                                <span>手机号码：</span>
                                {{ shouhuoInfo.phone }}
                            </div>
                        </div>
                    </div>

                    <div class="item" v-if="peisong_type_text == '上门自提'">
                        <div class="item-title">厂家信息</div>
                        <div class="item-content">
                            <div class="phone">
                                <span>联系方式：</span>
                                {{ shequ.phone }}
                            </div>
                            <div class="address">
                                <span>厂家地址：</span>
                                {{ shequ.address }}
                            </div>
                        </div>
                    </div>

                    <!-- 备注信息 -->
                    <div class="item" v-if="orderObj.remark">
                        <div class="item-title">订单备注</div>
                        <div class="item-content">
                            <div class="wuliu-name">
                                <span>备注：</span>
                                {{ orderObj.remark }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 订单商品信息 -->
            <div class="order-product order-info">
                <div class="order-list-wrap">
                    <!-- 商品信息 -->
                    <div class="info-item">
                        <div class="info-title">
                            <div class="date">{{ info.createdTime }}</div>
                            <div class="order-code">
                                订单号：
                                <span>{{ info.orderNo }}</span>
                            </div>
                            <div class="order-state">{{ info.statusInfo }}</div>
                        </div>
                        <div class="info-good">
                            <div class="list-good">
                                <div class="item" v-for="(product_item, index) in info.products" :key="index">
                                    <div class="item-good flex">
                                        <div class="box-image cover" @click="mix_to_product(product_item)">
                                            <el-image :src="product_item.image">
                                                <div slot="error" class="image-slot">
                                                    <img :src="product_item.image" />
                                                </div>
                                            </el-image>
                                        </div>

                                        <div class="box-title">
                                            <div class="title" @click="mix_to_product(product_item)">
                                                {{ product_item.title }}
                                            </div>
                                        </div>

                                        <div class="box-sku">
                                            <div class="goods-sku">{{ product_item.keyVals }}</div>
                                        </div>
                                        <div class="box-num">x {{ product_item.num }}</div>
                                        <div class="box-price">{{ product_item.priceOld }} 元</div>
                                    </div>

                                    <div class="goods-action" v-if="info.orderStatus == 5">
                                        <!-- <button v-if="!is_jifen_goods && item.allow_actions.allow_refund" class="btn-goods-action" @click="refundApply(item)">申请售后</button> -->
                                        <!-- <button v-if="item.ifshouhou" class="btn-goods-action disabled">已售后</button> -->
                                        <!-- <button v-if="item.allow_actions.allow_logistics" class="btn-goods-action" @click="toRoute(`/orderLogistics?order_id=${order_id}&logistics_id=${fahuo_id}`)">查看物流</button> -->
                                        <button v-if="product_item.ifComment == 0" class="btn-goods-action" @click="to_review(product_item)">
                                            商品评价
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="info-heji">
                            <div class="money-box">
                                <div class="money-item">
                                    <div class="label"></div>
                                    <div class="value">
                                        共 <b class="count">{{ orderObj.productNum }}</b> 件
                                    </div>
                                </div>
                                <div class="money-item">
                                    <span class="label">商品总价：</span>
                                    <div class="value">
                                        <span class="money-num">￥{{ priceOldMath(orderObj.products) }}</span>
                                    </div>
                                </div>
                                <div class="money-item">
                                    <span class="label">运费：</span>
                                    <div class="value">
                                        <span class="money-num">￥{{ payInfo.yunfei ? payInfo.yunfei : 0 }}</span>
                                    </div>
                                </div>
                                <div class="money-item">
                                    <span class="label">折前应付金额：</span>
                                    <div class="value">
                                        <span class="money-num">
                                            ￥ {{ priceOldFormate(orderObj.products, payInfo.yunfei ? payInfo.yunfei : 0) }}
                                        </span>
                                    </div>
                                </div>
                                <div class="money-item">
                                    <span class="label">折后应付金额：</span>
                                    <div class="value">
                                        <span class="money-num money-total">￥{{ info.price }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 提示 -->
                    <div class="hintText">
                        <img src="@/assets/img/mine/hintImg.png" class="hintIcon" alt="" />
                        <div class="hintTextStr">
                            售后规则：享受7天无理由退货，保修期18个月，正常使用损坏，维修产生的运费公司承担。如不当操作损坏，公司维修收取相关成本费
                        </div>
                    </div>

                    <!-- 订单操作 -->
                    <div class="order-action-box">
                        <div class="btn-box">
                            <button class="btn-ripple fit-text" v-if="info.ifCancel == 1" @click="doCancel(info)">取消订单</button>
                            <button v-if="info.ifPay == 1" class="btn-ripple fit-text btn-bg" @click="doPay(info)">去支付</button>
                            <button v-if="info.ifDel == 1" class="btn-ripple fit-text btn-bg" @click="doDelete(info)">删除订单</button>
                            <button v-if="info.ifReceive == 1" class="btn-ripple fit-text btn-bg" @click="doReceive(info)">确认收货</button>
                            <!-- <button v-if="info.orderStatus >= 5" class="btn-ripple fit-text btn-bg" @click="doRefund(info)">售后</button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <order_cancel_modal ref="order_cancel_modal" @confirm="emitConfirm" data-type="取消" />
        <order_delete_modal ref="order_delete_modal" @confirm="emitConfirm" data-type="删除" />
        <order_receive_modal ref="order_receive_modal" @confirm="emitConfirm" data-type="收货" />
        <order_refund_modal ref="order_refund_modal" @confirm="emitConfirm" data-type="售后" />
    </div>
</template>

<script>
import order_cancel_modal from '@/components/order/order_cancel_modal.vue' //取消订单
import order_delete_modal from '@/components/order/order_delete_modal.vue' //删除
import order_receive_modal from '@/components/order/order_receive_modal.vue' //收货
import order_refund_modal from '@/components/order/order_refund_modal.vue' //售后

// import orderInfo from "@/components/order/orderInfo.vue"; //
import { mapState } from 'vuex'

export default {
    name: 'order-detail',
    components: {
        order_cancel_modal,
        order_delete_modal,
        order_receive_modal,
        order_refund_modal,
        // orderInfo,
    },
    data() {
        return {
            id: this.$route.query.id,
            order_id: this.$route.query.id,
            info: {},
            payInfo: {},
            shouhuoInfo: {}, //收货人信息
            fahuoInfo: {}, //发货信息
            total_product_number: 0,
            products: [],
            full_receive_address: '',
            //
            is_finish_pay: false, //
            //
            is_jifen_goods: false,
            //

            orderObj: {}, //订单信息
            detail: {}, //订单信息

            pay_info: {}, //支付信息
            fahuo_info: {}, //发货信息
            peisong_info: {}, //门店配送信息
            peisong_type_text: '',
            peisong_type: '',

            is_payed: false, //是否已支付
            is_fahuo: false, //是否已发货
            is_mendian_peisong: false, //是否门店配送

            shequ: {},

            xianxia_imgs: [], //线下凭证信息
            is_xianxia: false, //是否线下转款
            pay_type: '', //支付方式
        }
    },
    computed: {
        ...mapState(['defaultAvatar']),
        priceOldFormate() {
            return (list, yunfei) => {
                function isArray(arg) {
                    if (typeof Array.isArray === 'undefined') {
                        return Object.prototype.toString.call(arg) === '[object Array]'
                    }
                    return Array.isArray(arg)
                }
                if (list && isArray(list)) {
                    let num = 0
                    for (let index = 0; index < list.length; index++) {
                        let item = list[index]
                        let priceOld = Number(item.priceOld)
                        num += priceOld
                    }
                    num += Number(yunfei)
                    num = num.toFixed(2)
                    return num
                } else {
                    return 0
                }
            }
        },
        priceOldMath() {
            return (list) => {
                function isArray(arg) {
                    if (typeof Array.isArray === 'undefined') {
                        return Object.prototype.toString.call(arg) === '[object Array]'
                    }
                    return Array.isArray(arg)
                }
                if (list && isArray(list)) {
                    let num = 0
                    for (let index = 0; index < list.length; index++) {
                        let item = list[index]
                        let priceOld = Number(item.priceOld)
                        num += priceOld
                    }
                    return num.toFixed(2)
                } else {
                    return 0
                }
            }
        },
        invoiceTypeToStr() {
            return (val) => {
                if (val == 1) {
                    return '普通发票'
                } else if (val == 2) {
                    return '专用发票'
                }
            }
        },
        payTypeToStr() {
            return (val) => {
                if (val.alipay != undefined) {
                    return '支付宝'
                } else if (val.applet != undefined) {
                    return '微信'
                } else if (val.balance != undefined) {
                    return '余额'
                } else {
                    return '未知'
                }
            }
        },
    },
    watch: {
        orderObj(data) {
            let { shouhuoInfo, status, pay_info, fahuo_info, peisong_type, shequ } = data

            this.peisong_type = peisong_type
            this.shequ = shequ
            this.shouhuoInfo = shouhuoInfo
            this.pay_info = pay_info

            //订单状态码(-5待支付 -3售后处理中 -1无效 0待成团 2待发货 3待收货 4已收货)
            if (status != -5 && status != -1 && status != 0) {
                this.is_payed = true
            }

            //配送方式
            let peisong_map = {
                1: '上门自提',
                2: '社区配送',
                3: '普通快递',
                4: '',
                5: '',
            }

            //社区购配送方式(1自提 2社区配送 3快递)

            this.peisong_type_text = peisong_map[peisong_type] || ''
            //门店配送订单需要显示配送员信息
            if (this.peisong_type_text == '同城配送') {
                this.is_mendian_peisong = true
                this.peisong_info = fahuo_info
            }

            //发货信息
            if (fahuo_info && fahuo_info.company) {
                this.fahuo_info = fahuo_info
                this.is_fahuo = true //已经发货
            }
        },
    },
    created() {
        this.setView()
    },
    methods: {
        emitConfirm() {
            this.setView()
        },
        setView() {
            this.query_order()
        },

        query_order() {
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'orders_detail',
                    id: this.id,
                },
            }).then((res) => {
                let { code, data, msg } = res
                if (code == 200) {
                    this.info = data
                    let { payInfo, products, shouhuoInfo, fahuoInfo } = data

                    this.payInfo = payInfo
                    this.products = products
                    this.fahuoInfo = fahuoInfo
                    this.is_finish_pay = parseFloat(data.pricePayed) > 0

                    //
                    this.shouhuoInfo = shouhuoInfo
                    if (shouhuoInfo) {
                        let { country, province, city, area, address } = shouhuoInfo
                        this.full_receive_address = [country, province, city, area, address].filter((v) => v).join(' ')
                    }

                    //
                    //支付方式

                    //凭证图片
                    this.orderObj = data
                    this.detail = data
                }
            })
        },
        to_review(item) {
            this.$router.push({
                path: '/order-review-submit',
                query: {
                    order_id: this.order_id,
                    inventoryId: item.id,
                },
            })
        },

        doCancel(item) {
            this.$refs.order_cancel_modal.init(item)
        },
        doPay(item) {
            this.$router.push({
                path: '/payment-methods',
                query: {
                    id: item.id,
                },
            })
        },
        doDelete(item) {
            this.$refs.order_delete_modal.init(item)
        },
        doReceive(item) {
            this.$refs.order_receive_modal.init(item)
        },
        doRefund(item) {
            this.$refs.order_refund_modal.init(item)
        },

        emitConfirmDelete() {
            this.$router.back()
        },
    },
}
</script>

<style scoped lang="less">
.page {
    .main-title {
        .flex-between();
        padding: 0 32px;
        text-align: left;
        height: 56px;
        line-height: 56px;
        background: #ffffff;
        font-size: 16px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #333333;

        button {
            min-width: 96px;
            height: 30px;
            line-height: 30px;
            background: #ff4d00;
            color: #fff;
            font-size: 14px;
            font-weight: bold;
        }
    }
}

.page-ctx {
    margin-top: 24px;
    padding: 24px 32px;
    background: #fff;
}

.step-box {
    .flex-center();
    padding: 55px 0;

    .step-item {
        text-align: center;

        &.active {
            .step-number {
                .step-num {
                    background: #ff5f00;
                    color: #ffffff;
                }

                .step-line {
                    background: #ff4d00;
                }
            }
        }

        .step-number {
            margin: 0 auto;
            .flex();

            .step-line {
                width: 147px;
                height: 2px;
                background: #f5f5f5;

                &.step-line-1 {
                    visibility: hidden;
                }

                &.step-line-6 {
                    visibility: hidden;
                }
            }

            .step-num {
                width: 44px;
                height: 44px;
                line-height: 44px;
                background: rgba(223, 84, 38, 0.06);
                border-radius: 50%;

                font-size: 20px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #999999;
            }
        }

        .step-title {
            margin-top: 14px;
            margin-bottom: 10px;
            font-family: OPPOSans, OPPOSans;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
        }

        .step-date {
            font-family: OPPOSans, OPPOSans;
            font-weight: 400;
            font-size: 12px;
            color: #808080;
        }
    }
}

.order-other {
    margin-bottom: 24px;
    min-height: 156px;
    background: #ffffff;
    border: 1px solid #f5f5f5;

    .title {
        text-align: left;
        padding-left: 24px;
        height: 48px;
        line-height: 48px;
        background: #f9f9f9;
        border-bottom: 1px solid #f5f5f5;

        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;

        color: #333333;
    }

    .other {
        // .flex-between();
        display: flex;
        flex-wrap: wrap;
        padding: 20px 80px 0 80px;

        .item {
            width: 50%;
            margin-bottom: 36px;
            text-align: left;
            padding-right: 40px;

            // flex: 1;
            .item-title {
                font-size: 14px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #999999;
                margin-bottom: 24px;
            }

            .item-content {
                min-height: 20px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 20px;
                color: #666;

                > div {
                    margin-bottom: 12px;

                    span {
                        display: inline-block;
                        // min-width: 80px;
                    }
                }
            }
        }
    }
}

.order-product {
}

.pingzheng-box {
    .flex();
    flex-wrap: wrap;

    .pingzheng-item {
        border: 1px solid #eee;
        margin-bottom: 10px;
        margin-right: 10px;
    }
}

.order-info {
    .money-yh {
        span {
            color: #04be02;
            font-weight: bold;
        }
    }

    .money-heji {
        span {
            color: #ff4d00;
            font-weight: bold;
        }
    }

    .zhifufangshi-wrap {
        margin-bottom: 0 !important;
        padding: 10px 0;
        width: 100%;
        border-top: 1px dashed #e5e5e5;
        .flex();
        justify-content: flex-end;

        .zhifufangshi {
            .flex();

            .pay-item {
                .flex();
                margin-left: 10px;

                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                line-height: 24px;
                color: #ff4d00;

                .pay-title {
                    margin-right: 5px;
                }

                .pay-money {
                }
            }
        }
    }

    .order-list-wrap {
        .info-item {
            border: 1px solid #f5f5f5;
            margin-bottom: 44px;
        }

        .info-title {
            .flex-between();
            height: 48px;
            padding: 0 24px;
            background: #f9f9f9;
            border-bottom: 1px solid #f5f5f5;

            font-size: 14px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;

            .date {
            }

            .order-code {
                flex: 2;
                text-align: left;
                padding-left: 20px;

                span {
                }
            }

            .order-state {
                // min-width: 96px;
                height: 30px;
                line-height: 30px;
                // background: #FF4D00;
                color: #ff4d00;
                // color: #fff;
                font-size: 14px;
            }
        }

        .info-good {
            .list-good {
                .item {
                    border-bottom: 1px solid #f5f5f5;

                    &:last-child {
                        border-bottom: none;
                    }
                }

                .item-good {
                    padding: 20px;
                    border-bottom: 1px dashed #f5f5f5;

                    &:last-child {
                        border: none;
                    }

                    .box-image {
                        width: 100px;
                        height: 100px;
                        cursor: pointer;
                        border: 1px solid #f5f5f5;

                        /deep/ img {
                            width: 100px;
                            height: 100px;
                            object-fit: contain;
                            object-fit: cover;
                        }

                        img {
                            width: 100px;
                            height: 100px;
                            object-fit: contain;
                            object-fit: cover;
                        }
                    }

                    .box-title {
                        flex: 1;
                        text-align: left;
                        padding-left: 40px;

                        .title {
                            width: fit-content;
                            cursor: pointer;

                            &:hover {
                                color: #ff4d00;
                            }
                        }
                    }

                    .box-sku {
                        text-align: center;
                        min-width: 200px;
                    }

                    .box-num {
                        text-align: center;
                        min-width: 200px;
                    }

                    .box-price {
                        text-align: center;
                        min-width: 200px;

                        font-family: OPPOSans, OPPOSans;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                    }
                }

                .goods-action {
                    .flex();
                    justify-content: flex-end;
                    padding: 10px;

                    button {
                    }

                    .btn-goods-action {
                        padding-left: 10px;
                        padding-right: 10px;
                        margin-left: 10px;
                        min-width: 96px;
                        height: 30px;
                        background: #ff4d00;
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        color: #ffffff;
                        // border-radius: 14px;
                        transition: 0.3s;
                        border-radius: 4px;

                        &:hover {
                            opacity: 0.8;
                        }

                        &.disabled {
                            background: #e5e5e5;
                        }
                    }
                }
            }
        }
    }

    .hintText {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 44px;

        .hintIcon {
            width: 25px;
            height: 25px;
            margin-right: 12px;
        }

        .hintTextStr {
            font-size: 14px;
            line-height: 14px;
            color: #555555;
        }
    }

    // 商品信息汇总和订单操作

    .info-heji {
        background: #fafafa;
        padding: 24px 40px;
        border-top: 1px solid #f5f5f5;
        // .flex-between();
        align-items: flex-start;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 20px;
        color: #666;

        .money-box {
            text-align: right;

            .count {
                font-weight: normal;
                color: #666666;
            }

            .money-item {
                margin-bottom: 16px;
                display: flex;
                justify-content: flex-end;

                &:last-child {
                    margin-bottom: 0;
                }

                .label {
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                }

                .value {
                    min-width: 50px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                }

                .money-num {
                    &.money-total {
                        font-weight: bold;
                        font-size: 20px;
                        color: #ff5f00;
                    }
                }
            }
        }
    }

    .order-action-box {
        display: flex;
        justify-content: flex-end;

        .btn-box {
            // margin-top: 10px;

            button {
                transition: 0.3s;
                min-width: 120px;
                height: 32px;
                background: #ffffff;
                border: 1px solid #ff4d00;
                font-family: Arial, Arial;
                font-weight: 400;
                font-size: 14px;
                color: #ff4d00;

                & + button {
                    margin-left: 20px;
                }

                &.btn-bg {
                    background: #ff4d00;
                    color: #fff;
                }

                &:hover {
                    opacity: 0.7;
                }
            }
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/shop/order-detail.less"></style>
<style scoped lang="less" src="@/assets/h5css/shop/orderInfo.less"></style>
